import React, { useEffect, useState } from "react";
import DataGeneral from "../Reports/DataGeneral";
import CompararConReport from "../Reports/CompararConReport";
import MejoresResultadosReport from "../Reports/MejoresResultadosReport";
import axios from "axios";

const Reportes = () => {
  const [selectedTab, setSelectedTab] = useState("Data general");
  const [showReport, setShowReport] = useState({
    "Data general": false,
    "Comparar con...": false,
    "Mejores resultados": false,
  });

  const tabs = ["Data general", "Comparar con...", "Mejores resultados"];

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
    setShowReport((prev) => ({
      ...prev,
      [tab]: false, // Reset to first page when switching tabs
    }));
  };

  const handleShowReport = () => {
    setShowReport((prev) => ({
      ...prev,
      [selectedTab]: true,
    }));
  };

  const getTabContent = (tab) => {
    // if (!showReport[tab]) {
    //   return (
    //     <div style={{ textAlign: "center", padding: "20px" }}>
    //       <h2>{tab} Información</h2>
    //       <p>Esta es la información introductoria sobre {tab}.</p>
    //       <button
    //         onClick={handleShowReport}
    //         style={{
    //           padding: "10px 15px",
    //           backgroundColor: "#2E7D32",
    //           color: "white",
    //           border: "none",
    //           borderRadius: "5px",
    //           cursor: "pointer",
    //         }}
    //       >
    //         Ver Reporte
    //       </button>
    //     </div>
    //   );
    // } else {
    switch (tab) {
      case "Data general":
        return <DataGeneral />;
      case "Comparar con...":
        return <CompararConReport />;
      case "Mejores resultados":
        return <MejoresResultadosReport />;
      default:
        return null;
    }
    // }
  };

  return (
    <div style={{ width: "100%", fontFamily: "Arial, sans-serif" }}>
      {/* Tabs */}
      <div
        style={{
          display: "flex",
          borderBottom: "1px solid #ccc",
          width: "60%",
        }}
      >
        {tabs.map((tab) => (
          <div
            key={tab}
            onClick={() => handleTabClick(tab)}
            style={{
              flex: 1,
              padding: "12px",
              textAlign: "center",
              cursor: "pointer",
              backgroundColor: selectedTab === tab ? "#31C8A6" : "white",
              color: selectedTab === tab ? "white" : "black",
              fontWeight: selectedTab === tab ? "bold" : "normal",
              border: "1px solid #ccc",
            }}
          >
            {tab}
          </div>
        ))}
      </div>

      {/* Content */}
      <div style={{ padding: "20px" }}>{getTabContent(selectedTab)}</div>
    </div>
  );
};

export default Reportes;
